import { HISTreatmentIDs } from '../../shared/interfaces/newAdmissionInterface';
import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import { LookUpState, PayerLookUpState } from '../models/lookUpModel';
import actionTypes from '../types/lookUpType';

export const fetchLookUpValues = (
  lookUpSuccessCallback: any, uniquePayerId?: string | boolean,
): Action<any> =>
  updateAction(actionTypes.FETCH_LOOK_UP_VALUES, { lookUpSuccessCallback, uniquePayerId });

export const setLookUpValues = (lookUpValues: LookUpState): Action<LookUpState> =>
  updateAction(actionTypes.SET_LOOK_UP_VALUES, lookUpValues);

export const setPayerLookUpValues = (lookUpValues: PayerLookUpState): Action<PayerLookUpState> =>
  updateAction(actionTypes.SET_PAYER_LOOK_UP_VALUES, lookUpValues);

export const setDiagnosisValues = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_DIAGNOSIS_VALUES, payload);

export const clearLookup = (): Action<void> =>
  updateAction(actionTypes.CLEAR_LOOKUP);

export const fetchPackage = (searchKey: string, onSuccess: any, onError: any, searchWithRoomType: boolean = false): Action<any> =>
  updateAction(actionTypes.FETCH_PACKAGE, { searchKey, onSuccess, onError, searchWithRoomType });

export const clearPayerLookUp = (): Action<void> =>
  updateAction(actionTypes.CLEAR_PAYER_LOOKUP);

export const fetchInpatientStatusList = (): Action<any> =>
  updateAction(actionTypes.FETCH_INPATIENT_STATUSES);

export const setPayerClaimStatuses = (payload: any): Action<any> =>
 updateAction(actionTypes.SET_PAYER_CLAIM_STATUSES, payload);

export const setAllPayerClaimStatuses = (payload: any): Action<any> =>
 updateAction(actionTypes.SET_ALL_PAYER_CLAIM_STATUSES, payload);

export const setGrievanceStatuses = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_GRIEVANCE_STATUSES, payload);

export const setRIPayerClaimStatuses = (payload: any): Action<any> =>
updateAction(actionTypes.SET_REIMBURSEMENT_PAYER_CLAIM_STATUSES, payload);

export const fetchInPatientInsurerList = (): Action<any> =>
  updateAction(actionTypes.FETCH_ALL_INSURERS);

export const setAllInsurers = (payload: any[]): Action<any> =>
  updateAction(actionTypes.SET_ALL_INSURERS, payload);

export const setAllGrievance = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_ALL_GRIEVANCE, payload);

export const setAllGrievanceLookupAction = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_ALL_GRIEVANCE_LOOKUP, payload);

export const fetchAllOnMailPayers = (onSuccess: any = (): any => { }, onFailure: any = (): any => { }): Action<any> =>
  updateAction(actionTypes.FETCH_ALL_ONMAIL_PAYERS, { onSuccess, onFailure });

export const setAllOnMailPayers = (payload: any[]): Action<any> =>
  updateAction(actionTypes.SET_ALL_ONMAIL_PAYERS, payload);

export const fetchProviderSpecificRoomType = (insurerId: string, onSuccess: any, dateOfAdmission?: any): Action<any> =>
  updateAction(actionTypes.FETCH_PROVIDER_ROOM_TYPES, { insurerId, onSuccess, dateOfAdmission });

export const fetchGrievanceType = (payerLookUpReqObj: any): Action<any> =>
  updateAction(actionTypes.FETCH_GRIEVANCE_TYPES, { payerLookUpReqObj });

export const fetchGreivanceLookUp = (onSuccess: any): Action<any> =>
  updateAction(actionTypes.FETCH_GRIEVANCE_LOOK_UP, {onSuccess});

export const fetchRolesMaster = (): Action<any> =>
  updateAction(actionTypes.FETCH_ROLE_MASTER);

export const updateRoleMaster = (payload: any): Action<any> =>
  updateAction(actionTypes.UPDATE_ROLE_MASTER, payload);

export const fetchClaimDetailMandatoryClassifications = (currentStatus: string, productCode: any, payerId: any,
  onSuccess: any = (): any => { }): Action<any> =>
  updateAction(actionTypes.FETCH_MANDATORY_CLASSIFICATIONS, { currentStatus, productCode, payerId, onSuccess });

export const fetchOtherClaimDetailMandatoryClassifications = (payload: any): Action<any> => {
 return updateAction(actionTypes.FETCH_OTHER_MANDATORY_CLASSIFICATIONS, payload);
};

export const fetchLookupMaster = (): Action<any> =>
  updateAction(actionTypes.FETCH_LOOKUP_MASTER);

export const otherTreatmentSelected = (payload: any): Action<any> =>
  updateAction(actionTypes.OTHER_TREATMENT_SELECTED, payload);

export const setDynamicLookUpForDiagnosis = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_DYNAMIC_DIAGNOSIS_VALUES, payload);

export const setDynamicLookUp = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_DYNAMIC_LOOKUP_VALUES, payload);

export const setDocotorList = (): Action<any> =>
  updateAction(actionTypes.SET_DOCTOR_VALUES);

export const setSynonymValue = (synonymValue: any[]): Action<any> => ({
  type: actionTypes.SYNONYM_TREATMENT_VALUE, ...{ synonymValue },
});

export const setBillDetail = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_BILL_DETAIL, payload);
export const setTreatmentValue = (treatmentValue: any): Action<any> =>
  updateAction(actionTypes.SYNONYM_TREATMENT_DATA_VALUE, treatmentValue);

export const setDiagnosisValue = (diagnosisValue: any): Action<any> =>
  updateAction(actionTypes.SYNONYM_DIAGNOSIS_DATA_VALUE, diagnosisValue);

export const fetchDiagnosisLookup = (diagnosisDynamicLookup: any): Action<any> =>
  updateAction(actionTypes.FETCH_DIAGNOSIS_LOOKUP_REQUEST, diagnosisDynamicLookup);

export const fetchLookup = (dynamicLookup: any, masterType: any): Action<any> =>
  updateAction(actionTypes.FETCH_LOOKUP_BYVALUE_REQUEST, { dynamicLookup, masterType });

export const getHISTreatmentValuesFromLookUp = (masterIds: HISTreatmentIDs, onLookUpSuccess: any, onLookUpFailure: any): Action<any> =>
  updateAction(actionTypes.GET_HIS_TREATMENT_LOOKUP_VALUES, { masterIds, onLookUpSuccess, onLookUpFailure });
